import { queryClient } from '../main';
import { persistor } from '../store';

export const performLogout = () => async (dispatch) => {
  dispatch({ type: 'LOGOUT' });

  localStorage.removeItem('authToken');
  localStorage.removeItem('tokenExpiresAt');
  sessionStorage.clear();

  if (queryClient) queryClient.clear();

  await persistor.purge();

  // window.location.reload();
};
